import React from "react";
import PublicNavbar from "../components/layout/PublicNavbar";
import Footer from "../components/layout/Footer";
import Seo from "../components/Seo";

const steps = [
  { t: "Startup applies", b: "Founder submits profile, funding requirement, and documents. Admin runs KYC and approval." },
  { t: "Investor onboards", b: "Investor completes profile, preferences and KYC. Admin approves and assigns tier." },
  { t: "Match engine runs", b: "Weighted rule-based scoring + Claude Sonnet 4.5 match reasoning on top." },
  { t: "Interest expressed", b: "Investor clicks Express Interest. Admin is notified. Predefined queries can be sent." },
  { t: "Response reviewed", b: "Startup responds. Admin approves before sharing with investor." },
  { t: "Deal room opens", b: "Structured workspace: docs, notes, NDA, term sheet, due-diligence checklist, stages." },
];

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-transparent text-ink">
      <Seo
        title="How It Works | VenturaZ Diligence & Deal Journey"
        description="From onboarding to closed deal: see how VenturaZ pairs startups with investors through AI-scored discovery, curated deal rooms, due diligence and e-signature."
        path="/how-it-works"
      />
      <PublicNavbar />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="overline mb-4">HOW IT WORKS</div>
        <h1 className="font-display text-4xl lg:text-6xl text-ink leading-tight max-w-3xl">Six deliberate steps between capital and conviction.</h1>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
          {steps.map((s, i) => (
            <div key={s.t} className="border border-white/10 bg-white/70 backdrop-blur p-6 flex gap-5">
              <div className="font-display text-4xl text-gold/70">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="font-heading text-ink text-lg">{s.t}</div>
                <div className="text-ink-muted text-sm mt-2 leading-relaxed">{s.b}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
